import connect from '@elab/core/store/connect';
import { actions as uiAction } from '@elab/core/store/ui';
import dynaForms from '@elab/core/utils/dynaForms';
import { compareState } from '@elab/core/utils/webComponent';

import { FormElement } from './Form';

class _FormField extends FormElement {
    static get properties() {
        return {
            step: { type: Number },
            hidden: { type: Boolean, reflect: true },
            required: { type: Boolean, reflect: true },
            error: { type: Boolean, reflect: true },
            scrollToField: { type: Boolean, attribute: false },
        };
    }

    constructor() {
        super();

        this.step = 0;
        this.hidden = true;
        this.required = false;
        this.error = false;
        this.scrollToField = false;
    }

    shouldUpdate(changedProps) {
        return [
            ['step'],
            ['fieldValue', 'value'],
            ['scrollToField'],
            ['error'],
            ['required'],
            ['hidden'],
        ].some(item => compareState(this, changedProps, ...item));
    }

    updated(changedProps) {
        if (changedProps.has('scrollToField') && this.scrollToField) {
            this.dispatchEvent(new CustomEvent('scroll-to-element'));
            this.dispatchEvent(new CustomEvent('reset-scroll-to'));
        }
    }
}

const mapStateToProps = (state, ctx) => {
    const field = ctx.fieldValue;

    return {
        step: ctx.getState(state).step || 0,
        hidden: !field || (field.type && field.type.toLowerCase() === 'hidden'),
        required: field && field.required,
        error: field && field.error,
        scrollToField: field && field.scrollToField,
    };
};

const mapDispatchToEvents = (dispatch, ctx) => {
    const actions = dynaForms.getActions(ctx.storeName);
    return {
        'scroll-to-element': () => dispatch(uiAction.scrollToCenter({ element: ctx })),
        'reset-scroll-to': () =>
            dispatch(actions.setScrollToField({ name: ctx.name, value: false })),
    };
};

export const FormField = connect(mapStateToProps, mapDispatchToEvents)(_FormField);

export default () => customElements.define('e2-form-field', FormField);
